import { IDesignedString } from '@/models/Common/interfaces/ICommonDomesticPlace';
import clsx from 'clsx';
import React, { CSSProperties } from 'react';
import { getJoyDesignedStringStyle } from '@/utils/JoyStyleUtils';

import styles from './ProductBadges.module.scss';
import { hasItems } from '@/utils';

interface IProductBadgesProps {
  badges?: IDesignedString[] | null;
  className?: string;
}

const getBadgeStyle = (badge: IDesignedString): CSSProperties => {
  const designedStringStyle = getJoyDesignedStringStyle(badge);

  return {
    ...designedStringStyle,
    border: `0.1rem solid ${designedStringStyle.borderColor}`,
  };
};

/**
 * 상품 속성 뱃지들
 * e.g. '숙박대전'
 */
const ProductBadges: React.FC<IProductBadgesProps> = ({ badges, className }) => {
  if (!badges || !hasItems(badges)) {
    return null;
  }

  return (
    <div className={clsx(styles.container, className)}>
      {badges.map((badge, idx) => (
        <span key={idx} style={getBadgeStyle(badge)} className={styles.badge}>
          {badge.title}
        </span>
      ))}
    </div>
  );
};

export default ProductBadges;
